import { render, staticRenderFns } from "./FourthStep.vue?vue&type=template&id=180d2d9a"
import script from "./FourthStep.vue?vue&type=script&lang=js"
export * from "./FourthStep.vue?vue&type=script&lang=js"
import style0 from "./FourthStep.vue?vue&type=style&index=0&id=180d2d9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports